module.exports = __webpack_public_path__ + "e03a0e231b5ff7989e4260cc7726e20f.svg";